export const calculateBiasScore = (maleCount, femaleCount) => {
    let score = 0
    if (femaleCount || maleCount) {
        score = (maleCount - femaleCount) / (femaleCount + maleCount)
        return {
            score: score,
            description: getBiasDescription(score, maleCount, femaleCount)
        }
    }
    return {
        score: score,
        description: 'Unknown'
    }
}

const getBiasDescription = (score, maleCount, femaleCount) => {
    if (score > 0.3 && maleCount > 4) {
        return 'Strongly masculine'
    } else if (score > 0) {
        return 'Masculine'
    } else if (score === 0) {
        return 'Neutral'
    } else if (score < -0.3 && femaleCount > 4) {
        return 'Strongly feminine'
    } else if (score < 0) {
        return 'Feminine'
    }
    return 'Neutral'
}
